import { toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center"
};
import LlSwitch from '@/components/LlSwitch.vue';
export default {
  __name: 'LlDoubleSwitch',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    leftLabel: {
      type: String,
      required: true
    },
    rightLabel: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    density: {
      type: String,
      default: 'compact'
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    function setValue(value) {
      if (props.disabled) return;
      emit('update:modelValue', value);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("label", {
        onClick: _cache[0] || (_cache[0] = $event => setValue(false)),
        class: _normalizeClass(["pt-1 px-2 cursor-pointer font-weight-medium", !__props.modelValue ? 'text-primary' : 'text-gray-600'])
      }, _toDisplayString(__props.leftLabel), 3), [[_vShow, !__props.required]]), _createVNode(LlSwitch, {
        "model-value": __props.modelValue,
        "onUpdate:modelValue": setValue,
        disabled: __props.disabled,
        density: __props.density,
        "use-color-for-base": __props.modelValue,
        class: "my-0 mx-2"
      }, null, 8, ["model-value", "disabled", "density", "use-color-for-base"]), _withDirectives(_createElementVNode("label", {
        onClick: _cache[1] || (_cache[1] = $event => setValue(true)),
        class: _normalizeClass(["pt-1 px-2 cursor-pointer font-weight-medium", __props.modelValue ? 'text-primary' : 'text-gray-600'])
      }, _toDisplayString(__props.rightLabel), 3), [[_vShow, !__props.required]])]);
    };
  }
};